import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import BaseText from '@/components/BaseText.vue';
import ActionButton from '@/components/action_button/Index.vue';
import BulkKycApprove from '@/plugins/graphql/mutations/v2/bulk-kyc-approve.gql';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import ButtonLoaderMixin from '@/helpers/vue_mixins/ButtonLoaderMixin';
import OrderStatusesQuery from '@/plugins/graphql/queries/v2/order-statuses.gql';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
let MultipleOrderConfirmation = class MultipleOrderConfirmation extends Mixins(AlertMixin, ButtonLoaderMixin, RouterParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.selectedOrderUuids = [];
    }
    get title() {
        return `Selected Orders: ${this.orders.length}`;
    }
    async approveOrderKyc() {
        if (this.orders.length >= 2) {
            this.orders.forEach((order) => {
                this.selectedOrderUuids.push(order.uuid);
            });
        }
        this.requestOnFlight();
        await this.approveKycMutation()
            .then(() => {
            this.$emit('success-confirmation', 'kyc');
            this.successNotification('Successfully Approved Kyc!');
            this.selectedOrderUuids = [];
            this.orders = [];
        })
            .catch((e) => {
            this.selectedOrderUuids = [];
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async approveKycMutation() {
        return this.$apollo.mutate({
            mutation: BulkKycApprove,
            variables: {
                input: {
                    orders: this.selectedOrderUuids,
                },
            },
            refetchQueries: [
                {
                    query: OrderStatusesQuery,
                    variables: {
                        appUuid: this.appUUID,
                        status: this.status,
                        requiredKyc: true,
                    },
                },
            ],
        });
    }
};
__decorate([
    Prop({ type: Array, default: () => [] })
], MultipleOrderConfirmation.prototype, "orders", void 0);
__decorate([
    Prop({ type: String })
], MultipleOrderConfirmation.prototype, "status", void 0);
__decorate([
    Prop({ type: String })
], MultipleOrderConfirmation.prototype, "selectedButton", void 0);
MultipleOrderConfirmation = __decorate([
    Component({
        components: {
            BaseText,
            ActionButton,
        },
    })
], MultipleOrderConfirmation);
export default MultipleOrderConfirmation;
